const [...tab] = document.querySelectorAll('.tab')
const [...info] = document.querySelectorAll('.info')

console.log(info, tab)

tab?.forEach((tabItem, tabIndex) => {
  tabItem.addEventListener('click', function (e) {
    tab?.forEach((item) =>
      item.classList.remove(
        'text-white',
        'bg-gradient-to-r',
        'from-[#F9B233]',
        'to-[#EE7003]'
      )
    )
    info.forEach((infoItem, infoIndex) => {
      if (tabIndex === infoIndex) {
        infoItem.classList.add('block')
        infoItem.classList.remove('hidden')
        tabItem.classList.add(
          'text-white',
          'bg-gradient-to-r',
          'from-[#F9B233]',
          'to-[#EE7003]'
        )
      } else {
        infoItem.classList.remove('block')
        infoItem.classList.add('hidden')
      }
    })
  })
})
